import { useEffect, useState, useRef } from "react";
import Lenis from "lenis";
import { API } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/defaultContent";
import ErrorBoundary from "@/components/ErrorBoundary";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Signature from "@/components/site/Signature";
import Gallery from "@/components/site/Gallery";
import MenuSection from "@/components/site/MenuSection";
import Reviews from "@/components/site/Reviews";
import Events from "@/components/site/Events";
import Reservation from "@/components/site/Reservation";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const lenisRef = useRef(null);

  useEffect(() => {
    fetch(API + "/content", { credentials: "include" })
      .then((r) => r.json())
      .then((data) => data && setContent(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("static") === "1") return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el && lenisRef.current) lenisRef.current.scrollTo(el, { offset: -80 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <ErrorBoundary>
      <div className="bg-[#f9f6f0] text-[#1a1a1a] overflow-x-hidden">
        <Header content={content} scrollTo={scrollTo} />
        <Hero content={content} scrollTo={scrollTo} />
        <Marquee content={content} />
        <About content={content} />
        <Signature content={content} />
        <Gallery content={content} />
        <MenuSection content={content} />
        <Reviews content={content} />
        <Events content={content} />
        <Reservation content={content} />
        <Contact content={content} />
        <Footer content={content} scrollTo={scrollTo} />
      </div>
    </ErrorBoundary>
  );
}
